/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'display_monitor': {
    width: 200,
    height: 154.57,
    viewBox: '0 0 1325 1024',
    data: '<path pid="0" _fill="#333" d="M662.632 1024A542.052 542.052 0 01120.58 481.948V60.35h120.456v421.597a421.596 421.596 0 00843.192 0V60.35h120.456v421.597A542.052 542.052 0 01662.632 1024z"/><path pid="1" _fill="#333" d="M1264.912 120.58H60.352A56.614 56.614 0 01.123 60.35 56.614 56.614 0 0160.352.123h1204.56a56.614 56.614 0 0160.228 60.228 56.614 56.614 0 01-60.228 60.229zm-602.28 602.28a240.912 240.912 0 11240.912-240.912A240.912 240.912 0 01662.632 722.86zm0-361.368a120.456 120.456 0 10120.456 120.456 120.456 120.456 0 00-120.456-120.456z"/>'
  }
})
